module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9KfW9"))).then(() => module.bundle.root('5erN3'));